<div class="page-container" [class.loading]="isLoading">
    <app-header class="margin-bottom-2" [title]="'time-off-v3.createTimeOffPolicy'" [back]="true"></app-header>

    <app-steps
        [labels]="{ primary: 'save' }"
        #appSteps
        [steps]="
            timeOffPolicy.isUnlimited
                ? [basicFormStep, accrualSettingsStep, reviewStep]
                : [basicFormStep, accrualSettingsStep, carryoverAnBalanceStep, reviewStep]
        "
        action="Create"
        (onPrimary)="onSave()"
    >
        <app-step
            #basicFormStep
            [embeddedCard]="false"
            [stepForm]="basicInfoForm"
            step="time-off-v3.policyComponents.createPolicy.basicInfoStepTitle"
        >
            <app-basic-info-form #basicInfoForm></app-basic-info-form>
        </app-step>

        <app-step
            #accrualSettingsStep
            [stepForm]="accrualSettingsForm"
            [embeddedCard]="false"
            step="time-off-v3.policyComponents.createPolicy.accrualSettingsStepTitle"
        >
            <app-accrual-schedule-form #accrualSettingsForm></app-accrual-schedule-form>
        </app-step>

        <app-step
            #carryoverAnBalanceStep
            [stepForm]="carryoverBalance"
            [embeddedCard]="false"
            step="time-off-v3.policyComponents.createPolicy.carryoverBalanceCapStepTitle"
        >
            <app-carryover-balance-form #carryoverBalance></app-carryover-balance-form>
        </app-step>

        <app-step
            #reviewStep
            [stepForm]="reviewForm"
            [embeddedCard]="false"
            step="time-off-v3.policyComponents.createPolicy.reviewStepTitle"
        >
            <app-policy-review-form #reviewForm></app-policy-review-form>
        </app-step>
    </app-steps>
</div>
